// @flow
import PropTypes from 'prop-types';
import styled from 'styled-components';
import debounce from 'lodash/debounce';

import type { ButtonTheme } from '../typings';
import { BIG_BUTTON_HEIGHT } from '../../constants';

import DisplayText from './Text/DisplayText';
import { PIN_PAD_WIDTH } from './PinPad/constants';

/* eslint-disable */
const Button = styled.button`
  height: ${props => props.scale * BIG_BUTTON_HEIGHT}px;
  max-width: ${PIN_PAD_WIDTH}px;
  width: 100%;
  background-color: ${props =>
    (props.buttonTheme && props.theme.button[props.buttonTheme].bg) ||
    props.theme.btnBrand};
  border-radius: 32px;
  border: none;
  cursor: pointer;

  &:active {
    background-color: ${props =>
      (props.buttonTheme && props.theme.button[props.buttonTheme].bgClicked) ||
      props.theme.btnBrandClicked};
  }

  &:hover:not(:active) {
    background-color: ${props =>
      (props.buttonTheme && props.theme.button[props.buttonTheme].bgHover) ||
      props.theme.btnBrandHover};
  }

  &:focus {
    outline: 0;
  }
`;

const Label = styled(DisplayText)`
  ${Button}:active & {
    color: ${props =>
      (props.buttonTheme &&
        props.theme.button[props.buttonTheme].textClicked) ||
      props.theme.brand};
  }
`;
/* eslint-enable */

type Props = {
  label: string,
  buttonTheme: ButtonTheme,
  onPress: () => void,
  scale: number
};

export default function RoundedCornerButton({
  label,
  buttonTheme,
  onPress,
  scale,
  ...restProps
}: Props) {
  const onClick = debounce(onPress, 500);

  const fontSize = 24 * scale + 'px';

  return (
    // $FlowFixMe
    <Button onClick={onClick} buttonTheme={buttonTheme} scale={scale} {...restProps}>
      <Label fontSize={fontSize} bold buttonTheme={buttonTheme}>
        {label}
      </Label>
    </Button>
  );
}

RoundedCornerButton.propTypes = {
  label: PropTypes.string,
  buttonTheme: PropTypes.string,
  onPress: PropTypes.func,
  scale: PropTypes.number
};
